import React, { useMemo, useState } from 'react';
import useDebouncedValue from '../hooks/useDebouncedValue';

function StateDot({ open }) {
  return <span className={`app-dot${open ? ' is-open' : ''}`} title={open ? 'isOpen' : 'closed'} />;
}

export default function AppList({ apps, platformLabel, onEdit, onViewStats, onDelete, canWrite = true }) {
  const [query, setQuery] = useState('');
  const needle = useDebouncedValue(query, 250).trim().toLowerCase();

  const filtered = useMemo(() => {
    const list = Array.isArray(apps) ? apps : [];
    if (!needle) return list;
    return list.filter((app) =>
      `${app.appId} ${app.appUrl || ''}`.toLowerCase().includes(needle)
    );
  }, [apps, needle]);

  return (
    <div className="app-editor-card compact-card mt-3">
      <div className="app-editor-card-body compact-card-body">
        <div className="apps-head">
          <div>
            <div className="stats-section-title">
              {platformLabel ? `${platformLabel} Applications` : 'Applications'}
            </div>
            <div className="stats-section-subtitle">
              {needle ? `${filtered.length} з ${apps.length}` : `${apps?.length || 0} додатків`}
            </div>
          </div>

          <input
            className="f-input apps-search"
            placeholder="пошук за назвою або URL"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        {!filtered.length ? (
          <div className="stats-empty-state">
            <span className="empty-mark" aria-hidden="true">
              <i />
              <i />
              <i />
            </span>
            <div className="stats-empty-title">Нічого не знайдено</div>
            <div className="stats-empty-text">Спробуйте інший запит або скиньте пошук.</div>
          </div>
        ) : (
          <div className="apps-list">
            {filtered.map((app) => (
              <div className="app-row" key={app.id || app.appId}>
                <div className="app-row-main">
                  <div className="app-row-id">
                    <StateDot open={app.isOpen} />
                    {app.appId}
                  </div>
                  <div className="app-row-url" title={app.appUrl || ''}>
                    {app.appUrl || '—'}
                  </div>
                </div>

                <div className="app-row-actions">
                  <button type="button" className="fbtn" onClick={() => onEdit(app)}>
                    Edit
                  </button>
                  <button type="button" className="fbtn" onClick={() => onViewStats(app)}>
                    Clicks
                  </button>
                  {canWrite ? (
                    <button type="button" className="fbtn is-danger" onClick={() => onDelete(app)}>
                      Delete
                    </button>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
